module.exports = __webpack_public_path__ + "img/motomoto.5dce8cd8.svg";